export default __webpack_public_path__ + "static/Intro_Imagery_Header_Placeholder-369bb6621f3744bf2c4a0f6d815ec6a1.jpeg";